import React, { useMemo } from 'react';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import promoMedia from 'theme/promoMedia';

import { PromoDiskButton } from '../PromoDiskButton/PromoDiskButton';

const Container = styled.div`
    padding: 32px 0;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    column-gap: 4px;

    ${promoMedia.tablet744} {
        padding: 48px 0;
        margin: 0 auto;
        column-gap: 16px;
    }

    ${promoMedia.desktop1440} {
        padding: 64px 0;
        margin: 0 auto;
    }
`;

const PaginationSection = (props) => {
    const realVisiblePagesCount = Math.min(props.pagesCount, props.visiblePagesCount);
    let indexIncrement = 1;
    if (realVisiblePagesCount === props.visiblePagesCount) {
        const sideVisiblePagesCount = Math.floor(props.visiblePagesCount / 2);
        const availableRightPages = props.pagesCount - props.currentPage;
        const rightOffsetLeftovers = Math.max(0, sideVisiblePagesCount - availableRightPages);
        indexIncrement = Math.max(1, props.currentPage - sideVisiblePagesCount - rightOffsetLeftovers);
    }
    const memoArrayRealVisiblePageCount = useMemo(() => {
        return [...Array(realVisiblePagesCount)];
    }, [realVisiblePagesCount]);

    return (
        <>
            <Container>
                <PromoDiskButton iconName="arrow-left" isDisabled={props.currentPage === 1} href={`${props.href}/${props.currentPage - 1}`} />
                {memoArrayRealVisiblePageCount.map((item, index) => {
                    const pageNumber = index + indexIncrement;

                    return (
                        <PromoDiskButton key={index} caption={pageNumber} isSelected={props.currentPage === pageNumber} href={`${props.href}/${pageNumber}`} />
                    );
                })}
                <PromoDiskButton iconName="arrow-right" isDisabled={props.currentPage === props.pagesCount} href={`${props.href}/${props.currentPage + 1}`} />
            </Container>
        </>
    );
};

PaginationSection.propTypes = {
    href: PropTypes.string,
    pagesCount: PropTypes.number,
    visiblePagesCount: PropTypes.number, // сколько циферок отображаем (сейчас по умолчанию 5, нужно нечетное количество, чтобы выделенная страница была посередине)
    currentPage: PropTypes.number, // номер текущей страницы
};

export default PaginationSection;
